import { useLocation } from "react-router-dom";

const useIsDomainMode = () => {
  const location = useLocation();
  return location.pathname.includes("/add-domain");
};

export default useIsDomainMode;
